import Box from '@mui/material/Box'
import Chip from '@mui/material/Chip'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select, {SelectChangeEvent} from '@mui/material/Select'
import {deepPurple, grey} from '@mui/material/colors'
import {Theme, useTheme} from '@mui/material/styles'
import * as React from 'react'

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 'inherit',
    },
  },
}

function getStyles(needle: string, haystack: readonly string[], theme: Theme) {
  return {
    fontWeight: haystack.includes(needle)
      ? theme.typography.fontWeightMedium
      : theme.typography.fontWeightRegular,
  }
}
interface Props {
  label: string
  entities: {key: any; value: any}[]
  values: {key: any; value: any}[]
  setValues: React.Dispatch<React.SetStateAction<{key: any; value: any}[]>>
}
export default function MultipleSelectChip({label, entities, values, setValues}: Props) {
  const theme = useTheme()

  const handleChange = (event: SelectChangeEvent<string[]>) => {
    const {
      target: {value},
    } = event

    const selected =
      typeof value === 'object' &&
      value?.map((s) => (typeof s === 'string' ? entities.find((ent) => ent.value === s)! : s))

    selected && setValues(selected)
    const check = 'here'
  }

  return (
    <FormControl variant={'filled'} sx={{width: '100%'}} size='small'>
      <InputLabel id='multiple-chip-label'>{label}</InputLabel>
      <Select
        fullWidth
        labelId='multiple-chip-label'
        variant='filled'
        id='multiple-chip'
        multiple
        value={values?.map((m) => m.value)}
        onChange={handleChange}
        renderValue={(selected) => (
          <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 0.5}}>
            {selected?.map((ent) => (
              <Chip
                size='small'
                sx={{bgcolor: deepPurple[100], color: grey[900], P: 0, m: 0}}
                key={ent}
                label={ent}
              />
            ))}
          </Box>
        )}
        size={'small'}
        MenuProps={MenuProps}
      >
        {entities?.map((ent) => (
          <MenuItem
            key={ent.value}
            value={ent.value}
            style={getStyles(
              ent.value,
              values.map((m) => m.value),
              theme
            )}
          >
            {ent.value}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
